export enum Department{
    RM = "RM",
    AS = "AS",
    AV = "AV",
}